import { createContext } from 'react';
import type { ConfirmOptions } from './confirm';

/** What the provider hands down: ask, and find out what they said. */
export type Confirm = (options: ConfirmOptions) => Promise<boolean>;

/* Kept out of confirm.tsx, which imports ./ui — the component library, edited
   constantly. See src/core/i18nContext.ts. */
export const ConfirmContext = createContext<Confirm | null>(null);
